import { animate } from '@play-co/timestep-core/ui';
import { getPet } from 'src/game/pet';
import {
  LockedReason,
  AvailableDisabledFeatures,
} from 'src/game/popups/PopupFeatureDisabled';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import sounds from 'src/lib/sounds';
import LockedButtonOverlay from '../LockedButtonOverlay';
import { FooterButtonType, FooterButton } from './FooterButton';
import { user } from 'src/StateObserver';

export class LockableFooterButton<
  T extends FooterButtonType = FooterButtonType,
> extends FooterButton {
  private isLocked: boolean = false;
  private lockedReason?: LockedReason;
  private lockedButtonOverlay: LockedButtonOverlay | null = null;

  constructor(opts: { type: T; isLocked?: boolean }) {
    super(opts);
    this.setLocked(opts.isLocked ?? false);
  }

  protected setSize(width: number, height: number) {
    this.updateOpts({ width, height });
    this.lockedButtonOverlay?.setSize(width, height);
  }

  public setLocked(isLocked: boolean, reason?: LockedReason) {
    this.lockedReason = reason;
    if (this.isLocked === isLocked) {
      return;
    }

    this.isLocked = isLocked;
    if (isLocked) {
      const { width, height } = this.style;
      this.lockedButtonOverlay = this.addSubview(
        new LockedButtonOverlay({ width, height }),
      );
    } else if (this.lockedButtonOverlay) {
      const overlay = this.lockedButtonOverlay;
      animate(overlay)
        .commit()
        .now({ opacity: 0 }, 250, animate.linear)
        .then(() => overlay.removeFromSuperview());
      this.lockedButtonOverlay = null;
    }
  }

  public async onClick() {
    // Show feature disabled popup
    if (this.isLocked) {
      sounds.sfx.play('ok');

      if (this.lockedReason === 'wantToGoOut') {
        await getPet().conversation.waitForFinish();
        await getPet().startConversation();
        return;
      }

      let feature = this.opts.type as AvailableDisabledFeatures;

      switch (this.opts.type) {
        case 'game':
          // This care count should be removed if we resolve bpoints-from-puzzle to enabled
          this.lockedReason =
            user().care.careActionCount <= 2 ? 'careRequired' : undefined;
          break;
        case 'slots':
          feature = 'game';
          break;
        case 'care':
          feature = 'care';
          break;
      }

      await openPopupPromise('popupFeatureDisabled', {
        feature,
        reason: this.lockedReason,
      });
    } else {
      return this.handleClick();
    }
  }

  protected async handleClick() {
    return super.onClick();
  }
}
